export default "__VITE_ASSET__DBvPJzJL__"